import DiscreteBar from './DiscreteBar';
import { BarOrientation } from './types';
import CategoricalIndicator from './CategoricalIndicator';
import { CombinedPalette } from '@fe/weather';

const Combined = (props: { palette: CombinedPalette }) => {
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                {props.palette.palettes.map((item, index) => (
                    <>
                        {props.palette.displayType === 'discreteBar' && (
                            <DiscreteBar
                                key={index}
                                showLabels={index === props.palette.palettes.length - 1}
                                data={{
                                    id: props.palette.id,
                                    type: 'discreteBar',
                                    name: item.name,
                                    colors: props.palette.colors.slice(item.offset, item.offset + item.length),
                                    values: props.palette.values,
                                    units: props.palette.units
                                }}
                                orientation={BarOrientation.Vertical}
                            />
                        )}

                        {props.palette.displayType === 'categorical' && (
                            <CategoricalIndicator
                                key={index}
                                showLabels={index === props.palette.palettes.length - 1}
                                data={{
                                    id: props.palette.id,
                                    type: 'categorical',
                                    name: item.name,
                                    entries: props.palette.colors.slice(item.offset, item.offset + item.length).map((x, i) => ({
                                        color: x,
                                        label: props.palette.values[i].toString()
                                    })),
                                    units: props.palette.units
                                }}
                            />
                        )}
                    </>
                ))}
            </div>
        </div>
    );
};

export default Combined;
